import "./static/vendor/animate.css/animate.min.css"
import "./static/vendor/aos/aos.css"
import "./static/vendor/bootstrap/css/bootstrap.min.css"
import "./static/vendor/bootstrap-icons/bootstrap-icons.css"
import "./static/vendor/boxicons/css/boxicons.min.css"
import "./static/vendor/glightbox/css/glightbox.min.css"
import "./static/vendor/swiper/swiper-bundle.min.css"
import "./static/css/style.css"
